<!-- src/components/FullTriggerBox.svelte
     v12 step 1 — 蓋板文字盒(站在白遮罩上)
     props:
       title: string                                       - 蓋板大標
       lede: string                                        - 副標 / 引言(可選)
       content: { type: 'text', value: string }
              | { type: 'image', value: { url, description, credit } }
              [ ]                                          - 段落陣列(物件,對齊 ArchieML 巢狀 freeform 輸出)
       recommendation: { title, url }[]                    - 延伸閱讀(可選)
-->
<script>
  export let title = ''
  export let lede = ''
  export let content = []
  export let recommendation = null
</script>

<style>
  .full-trigger-wrap {
    margin: 0 auto;
    pointer-events: initial;
    min-height: 80vh;
    padding: 4rem 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .full-trigger-box {
    width: 90%;
    max-width: 600px;
    padding: 2rem 1.75rem;
    color: var(--color-text, #222222);
  }
  .full-trigger-box h2 {
    font-size: 1.75rem;
    letter-spacing: 0.05em;
    margin: 0 0 1.2rem 0;
    color: var(--color-text, #222222);
    font-weight: 600;
  }
  .full-trigger-box .lede {
    font-size: 1.1rem;
    color: var(--color-text-dim, #777777);
    margin: 0 0 1.5rem 0;
    line-height: 1.8;
    font-weight: 400;
  }
  .full-trigger-box p {
    padding-bottom: 1.2rem;
    margin: 0;
    font-size: 1.05rem;
    line-height: 2;
    letter-spacing: 0.025em;
    color: var(--color-text, #222222);
  }
  .full-trigger-box :global(strong) {
    color: var(--color-accent, #d44545);
    font-weight: 600;
  }
  .full-trigger-box :global(a) {
    color: var(--color-blue, #3e6a8a);
    text-decoration: underline;
  }

  /* inline 圖片區 */
  .full-trigger-box .inline-image {
    margin: 1.5rem 0 2rem;
  }
  .full-trigger-box .inline-image img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 2px;
  }
  .full-trigger-box .inline-image .caption {
    font-size: 0.88rem;
    color: var(--color-text-dim, #777777);
    margin-top: 0.6rem;
    line-height: 1.6;
  }
  .full-trigger-box .inline-image .credit {
    font-size: 0.75rem;
    color: var(--color-text-muted, #9aa5b0);
    margin-top: 0.3rem;
    letter-spacing: 0.05em;
  }

  .full-trigger-box .recommend-section {
    margin-top: 2rem;
    padding-top: 1.5rem;
    border-top: 1px solid #d0cdc6;
  }
  .full-trigger-box .recommend-section h3 {
    font-size: 1.1rem;
    padding-bottom: 0.6rem;
    letter-spacing: 0.08em;
    color: var(--color-accent, #d44545);
    margin: 0;
    font-weight: 600;
  }
  .full-trigger-box .recommend-section a {
    display: block;
    padding: 0.5rem 0;
    color: var(--color-blue, #3e6a8a);
    text-decoration: none;
    transition: color 0.2s;
    font-size: 0.95rem;
  }
  .full-trigger-box .recommend-section a:hover {
    color: var(--color-accent, #d44545);
  }

  @media (max-width: 650px) {
    .full-trigger-box {
      width: 92%;
      padding: 1.5rem 1.25rem;
    }
    .full-trigger-box h2 { font-size: 1.5rem; }
    .full-trigger-box .lede { font-size: 1rem; }
    .full-trigger-box p { font-size: 1rem; }
  }
</style>

<div class="full-trigger-wrap">
  <div class="full-trigger-box">
    <h2>{title}</h2>
    {#if lede}
      <p class="lede">{lede}</p>
    {/if}
    {#each content as item}
      {#if item.type === 'image'}
        <figure class="inline-image">
          <img src={item.value?.url} alt={item.value?.description || ''} />
          {#if item.value?.description}
            <figcaption class="caption">{item.value.description}</figcaption>
          {/if}
          {#if item.value?.credit}
            <div class="credit">{item.value.credit}</div>
          {/if}
        </figure>
      {:else if item.type === 'text'}
        <!-- 支援 HTML(<strong>、<a>等) -->
        <p>{@html item.value}</p>
      {/if}
    {/each}
    {#if recommendation && recommendation.length > 0}
      <div class="recommend-section">
        <h3>延伸閱讀</h3>
        {#each recommendation as item}
          <a href={item.url} target="_blank" rel="noopener">{item.title}</a>
        {/each}
      </div>
    {/if}
  </div>
</div>
